<template>
  <v-container fluid>
    <drawer />
    <v-container fluid>
      <router-view />
    </v-container>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import Drawer from '@/components/settings/drawer/index'

export default {
  name: 'settings-panel',
  components: {
    Drawer
  },
  mounted () {
    this.load()
  },
  methods: {
    ...mapActions({
      load: 'settings/load'
    })
  }
}
</script>

<style scoped></style>
